import React from "react";
import Layout from "./Layout";
import { Card, CardContent } from "./components/ui/card";

import conversionImg from './assets/conversion.jpg';
import oneStopImg from './assets/onestop.jpg';
import experienceImg from './assets/experience.jpg';

export default function Resources() {

  const resources = [
    {
      title: "We Do Complete Data Conversions, Including Accounts Receivable",
      image: conversionImg,
    },
    {
      title: "We Are a One-Stop Shop Solution, We Do Everything In House",
      image: oneStopImg,
    },
    {
      title: "Decades of Durable Medical Equipment Software Development Experience",
      image: experienceImg,
    },
  ];

  return (
    <Layout>
      <h2 className="text-3xl md:text-4xl font-bold mb-6">
        Why We Are Different
      </h2>

      <div className="grid md:grid-cols-3 gap-6">
        {resources.map((item) => (
          <Card
            key={item.title}
            className="rounded-xl shadow-lg hover:shadow-xl hover:scale-105 transition-transform duration-300"
          >
            <CardContent className="p-4">
              <img
                src={item.image}
                alt={item.title}
                className="w-full h-40 object-cover rounded-lg mb-4"
              />
              <h3 className="font-semibold text-lg">
                {item.title}
              </h3>
            </CardContent>
          </Card>
        ))}
      </div>
    </Layout>
  );
}